import {React} from "react";
import './Test.scss'

import Slider from "react-slick";
import "../../assets/styles/slick.css"
import "../../assets/styles/slick-theme.css"

const Test= () => {

    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      rtl: true
    };

    return(
            <div className="testP">
              
              <Slider {...settings}>
               <div>
            <h3>1</h3>
          </div>
          <div>
            <h3>2</h3>
          </div>
          <div>
            <h3>3</h3>
          </div>
          <div>
            <h3>4</h3>
          </div>
          <div>
            <h3>5</h3>
          </div>
          <div>
            <h3>6</h3>
          </div>
        </Slider>
            </div>
    )
}

export default Test;
